module.exports = __webpack_public_path__ + "static/media/paragon_2.3904f2a9.jpg";